<template>
  <div class="sidebar">
    <div
      class="sidebar-backdrop"
      @click="toggleSidebarPanel"
      v-if="isPanelOpen"
    ></div>
    <transition name="slide">
      <div v-if="isPanelOpen" class="sidebar-panel">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
import { store, mutations } from '@/store/index.js'
export default {
  computed: {
    isPanelOpen() {
      return store.isNavOpen
    },
  },
  methods: {
    toggleSidebarPanel: mutations.toggleNav,
    closeSidebarPanel: mutations.closeNav,
  },
}
</script>
<style>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.1);
  width: 100vw;
  height: 100vh;
  z-index: 987;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
}

.sidebar-panel {
  overflow-y: auto;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 988;
  padding: 3rem 20px 2rem 20px;
  width: 200px;
}
</style>
